import * as React from 'react';
import { useListContext, TextField,ShowButton } from 'react-admin';
import { Card, CardActions, CardContent, CardHeader, Avatar } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import {  PhoneDestField, PhoneExpField,formatDate } from '../references.js';
import FormDialogPayement from '../dialog/FormDialogPayement.js';

const cardStyle = {
    width: 300,
    margin: '0.5em',
    display: 'inline-block',
    verticalAlign: 'top'
};
const CustomGrid = () => {
    const { ids, data, basePath } = useListContext();
    return (
        <div style={{ margin: '1em' }}>
         
        {ids.map(id =>
            <Card key={id} style={cardStyle}>
                <CardHeader
                    title={data[id].camp_code+' : '+data[id].code}
                    subheader={data[id].status+'-'+formatDate(data[id].created_date)}
                    avatar={<Avatar icon={<PersonIcon />} />}
                />
                <CardContent>
                    Agent : <TextField source="agent_fullname" record={data[id]}/><br/>
                    Exp : <PhoneExpField source="tel_exp"  record={data[id]}  /><br/>
                    Dest : <PhoneDestField source="tel_dest"   record={data[id]}  /><br/>
                    Encaissé : <TextField source="total_encaisse"  record={data[id]} /> € - 
                    Reste  à payé : <TextField source="reste_a_payer"  record={data[id]} /> €<br/>
                    Total TTC : <TextField source="total_general" record={data[id]}  /> €
                </CardContent>
                <CardActions style={{ textAlign: 'right' }}>
                    <ShowButton resource="fret" basePath={basePath} record={data[id]} />
                    {data[id].reste_a_payer?<FormDialogPayement from="list" data={data[id]} /> :  null}

                </CardActions>
            </Card>
        )}
        </div>
    );
};

export default CustomGrid;